// extracted by mini-css-extract-plugin
export default {"message":"style_message__mptOO","attachments":"style_attachments__Akumi"};